import classNames from "classnames";
import styles from './external-ad.module.scss';
import {useDisplayAdByLayout} from "../../../../infrastructure/hooks/useDisplayAdByLayout";
import {Clear} from "../../../icons/clear";
import {ExternalAdContentUnit} from "./external-ad.content-unit";
import useAdStatus from "../../../../infrastructure/hooks/ads/useAdStatus";
import {AD_DISPLAYS} from "../../../consts";

export const ExternalAdContent = ({
                                    controller,
                                    config,
                                    className,
                                    isMock = false,
                                    shouldRenderClosingButton = false,
                                    shouldRenderTitle = true,
                                    onClose = null,
                                    FallbackComponent = null
                                  }) => {
  if (!config) {
    return null;
  }

  const isTestAd = controller.state.appState.settings.config.adDisplay === AD_DISPLAYS.test;
  const adConfig = isTestAd ? {...config, adUnit: `${config.adUnit}_test`} : config;

  const {width, height, validLayouts, collapseEmptyDiv} = adConfig;
  const {shouldDisplayAd} = useDisplayAdByLayout(controller, validLayouts);

  if (!shouldDisplayAd) {
    return FallbackComponent ? FallbackComponent : null;
  }

  const handleCloseAd = () => onClose?.();

  const containerClassName = classNames({
    [styles.mock]: isMock,
    [styles.with_title]: shouldRenderTitle,
  }, styles.container, className);

  const mockProps = {
    className: classNames(styles.ad),
    style: {minWidth: width, minHeight: height}
  }

  const clearButtonProps = {
    className: classNames(styles.close_button),
    onClick: handleCloseAd
  }

  const unitProps = {
    controller,
    config: adConfig
  }

  const {isAdFilled} = useAdStatus(adConfig.adUnit);

  return isAdFilled || !collapseEmptyDiv ? <div className={containerClassName}>
    <div className={classNames(styles.text)}>Ad</div>
    {
      isMock ? <div {...mockProps}/> : <ExternalAdContentUnit {...unitProps}/>
    }
    {
      shouldRenderClosingButton ? <Clear {...clearButtonProps}/> : null
    }
  </div> : null
};